import type { UserConfigFragment } from "../generated/webapi.g";

declare global {
    interface Window {
        ga: (...args: any[]) => any;
    }
}

export const GA_INCLUDE = `
<script>
    window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
</script>
<script async src='https://www.google-analytics.com/analytics.js'></script>`;

export function initGAConfig(config: UserConfigFragment, clientId: string) {
    if (typeof window === "undefined" || !window.ga) {
        return;
    }

    if (config.analytics?.google_analytics_switch) {
        if (config.analytics?.poc_primary_analytics_id) {
            window.ga("create", config.analytics.poc_primary_analytics_id, "auto");
            window.ga("send", "pageview");
        }

        if (config.analytics?.poc_secondary_analytics_id) {
            window.ga("create", config.analytics.poc_secondary_analytics_id, "auto", "secondaryTracker");
            window.ga("secondaryTracker.send", "pageview");
        }
    }

    window.ga("create", clientId, "iheart.com", "ihrTracker");
    window.ga("ihrTracker.send", "pageview");
}

export function updateGAPageView(pathname: string) {
    if (typeof window !== "undefined" && window.ga) {
        window.ga("set", "page", pathname);
        window.ga("send", "pageview");
    }
}
